
import React from 'react';
import Icon from './index';

const vectors = 'M18.6447238,11.380673 L6.0232127,4.09351111 C5.8071873,3.96886349 5.54138413,3.96886349 5.32530794,4.09351111 C5.10948571,4.21805714 4.97630476,4.44860952 4.97630476,4.69785397 L4.97630476,19.2720762 C4.97630476,19.5213714 5.10948571,19.7519238 5.32530794,19.876419 C5.43339683,19.9388444 5.55387937,19.9700317 5.67426032,19.9700317 C5.79474286,19.9700317 5.9151746,19.9388444 6.0232127,19.876419 L18.6447746,12.5893587 C18.8606476,12.4648127 18.9937778,12.2342603 18.9937778,11.9850159 C18.993727,11.7357206 18.8605968,11.505219 18.6447238,11.380673 Z M6.37216508,18.0631365 L6.37216508,5.90684444 L16.8999111,11.9850159 L6.37216508,18.0631365 Z';

export default function Play(props) {
  return (
    <Icon {...props} viewBox="0 0 24 24" vectors={vectors} />
  );
}

